/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-06-19 14:55:01
 *
 *******************************************************/
// @flow
import _ from 'lodash';

import React, { Component } from 'react';
import { Banner, List } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import history from 'src/routes/history';

type Props = {
  list: Array<Object>,
  hasAction: boolean
};

type ComposedProps = Props & WithI18nProps;

class InvalidMetafieldsFound extends Component<ComposedProps> {
  state = {
    text: null
  };

  /**
   * Cut down text
   * Ex: custom:jeantest1; custom:jenatest2; custom:jenatest_special_character; custom:jenatest_number_text
   * will be: custom:jeantest1; custom:jenatest2; custom:jenatest_special_character; ... by width of content
   * @param {*} text
   * @param {*} maxWidth
   * @returns
   */
  truncateText = (text, maxWidth) => {
    let span = document.createElement('span');
    span.style.whiteSpace = 'nowrap';
    span.style.visibility = 'hidden';
    span.textContent = text;
    document.body.appendChild(span);

    if (span.offsetWidth <= maxWidth) {
      document.body.removeChild(span);
      return text;
    }

    let truncated = '';
    let words = text.split(';');
    for (let word of words) {
      word = word.trim();
      span.textContent = truncated + word + ';';
      if (span.offsetWidth > maxWidth) {
        break;
      } else {
        truncated += word + '; ';
      }
    }
    document.body.removeChild(span);
    return truncated + '...';
  };

  componentDidMount() {
    const { invalidMetafields = [], emptyMetafields = [] } = this.props;
    const grouped = _.groupBy(
      [...invalidMetafields, ...emptyMetafields],
      item => item.key + '_' + item.namespace
    );

    const merged = _.map(grouped, group => _.merge(...group));

    const allMetafields = merged
      .map(i => {
        return `${i.namespace}:${i.key}`;
      })
      .join('; ');

    if (document) {
      const title = document.getElementById('title-error-metafiled');
      const width = title.offsetWidth;
      const truncated = this.truncateText(allMetafields, width - 50);
      this.setState({ text: truncated });
    }
  }

  render() {
    const { text } = this.state;
    const { i18n, hasAction } = this.props;

    const propAction = hasAction
      ? {
          action: {
            onAction: () => {
              history.push('/metafield');
            },
            content: i18n.translate('AdminHTML.Metafield.Metafield.edit')
          }
        }
      : {};

    return (
      <Banner
        title={i18n.translate('AdminHTML.Metafield.InvalidMetafieldsFound.title')}
        status="warning"
        {...propAction}>
        <p id="title-error-metafiled">
          {i18n.translate('AdminHTML.Metafield.InvalidMetafieldsFound.content2')}
        </p>
        <List>{text && <List.Item>{text}</List.Item>}</List>
      </Banner>
    );
  }
}

export default withI18n()(InvalidMetafieldsFound);
